import { saveBudget } from './campana.actions'

export const saveBudgets = (obj) => dispatch =>{
    dispatch(saveBudget(obj))
}